import { render, staticRenderFns } from "./BigData.vue?vue&type=template&id=c58fab64&scoped=true&"
import script from "./BigData.vue?vue&type=script&lang=js&"
export * from "./BigData.vue?vue&type=script&lang=js&"
import style0 from "./BigData.vue?vue&type=style&index=0&id=c58fab64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58fab64",
  null
  
)

export default component.exports